import { initEmbeddingFeed } from '~/utils/EmbeddingFeed';
import { initEmbeddingFonts } from '~/utils/EmbeddingFonts';
import { initManagementSettings } from '~/utils/ManagementSettings';
import { initPreviewFeed } from '~/utils/PreviewFeed';

/**
 * Инициализация глобальных утилит
 * initEmbeddingFeed;
 * initEmbeddingFonts;
 * initPreviewFeed;
 * initManagementSettings;
 */
export const initUtilities = () => {
  window.SberLeadDeferredQueueFeed = [];
  
  /**
   * Утилита для встраивания ленты рекомендаций на сайт клиента
   */
  initEmbeddingFeed();

  /**
   * Встраивание шрифтов на сайте клиента для работы виджетов и ленты рекомендаций
   */
  initEmbeddingFonts();

  /**
   * Утилита для предпросмотра ленты рекомендаций на сайт клиента
   */
  initPreviewFeed();

  /**
   * Утилита для управления настройками из консоли
   */
  initManagementSettings();
};
